import { Controller } from "@hotwired/stimulus";

// depositSuccessController owns the X-close behaviour of the deposit success
// overlay (templates/streams/deposit.crypto.success.stream.html). Lives in
// its own controller so deposit-flow logic does not leak into the generic
// BottomSheetController used by every bottomsheet in the app.
export default class DepositSuccessController extends Controller {
  static values = { swapId: String };

  close() {
    const onPendingForThisSwap =
      this.swapIdValue &&
      window.location.pathname === `/deposit/crypto/order/${this.swapIdValue}`;

    this.hide();
    if (onPendingForThisSwap) {
      Turbo.visit("/home");
    }
  }

  hide() {
    this.element.setAttribute("inert", "");
    this.element.setAttribute("aria-hidden", "true");
    this.element.classList.add("hidden");
  }
}
